import { UserWindowPreference } from '@/app-modules/store/modules/user-preferences/user-window-preference';
import { ConnectionTimeoutOverride } from '@/app-modules/store/modules/user-preferences/connection-timeout-override';
import { NotificationPositionDefaults } from '@/components/chat/_domain';

enum DEFAULT_COLOURS {
  RED = '#ff0000',
  WHITE = '#ffffff',
  GREY = '#e0e0e0'
}

enum ColourTheme {
  Light = 'theme-light',
  Dark = 'theme-dark'
}

const defaultThemeColours = {
  [ColourTheme.Light]: {
    backgroundColour: '#e0e0e0',
    chatBackgroundColour: '#ffffff'
  },
  [ColourTheme.Dark]: {
    backgroundColour: '#555',
    chatBackgroundColour: '#444'
  }
};

const defaultColourTheme = ColourTheme.Light;

class UserPreferences {
  public username: string = '';
  public country: string = '';
  public rememberMe: boolean = false;
  public alertWords: string[] = [];
  public cmChatColour: string = DEFAULT_COLOURS.RED;
  public rememberWindowLayout: boolean = true;
  public windowPreferences: UserWindowPreference[] = [];
  public cmMessageColour: string = DEFAULT_COLOURS.RED;
  public chatFontSize: number = 13;
  public chatBackgroundColour: string = defaultThemeColours[defaultColourTheme].chatBackgroundColour;
  public backgroundColour: string = defaultThemeColours[defaultColourTheme].backgroundColour;
  public boldFont: boolean = false;
  public notificationSound: boolean = false;
  public jackpotNotificationSound: boolean = false;
  public displayTimestamps: boolean = true;
  public broadcastAllJackpots = true;
  public broadcastWorldsJackpots = false;
  public broadcastArcadeTopPrizes = false;
  public notificationPosition: string = NotificationPositionDefaults.TOPRIGHT;
  public colourTheme: ColourTheme = defaultColourTheme;
  public pinNavigationMenu: boolean = true;
  public playerNotesUsername: string = '';
  public logWebSocketActivity: boolean = false;
  public connectionTimeoutOverrides: ConnectionTimeoutOverride = new ConnectionTimeoutOverride();
}

export { UserPreferences, DEFAULT_COLOURS, ColourTheme, defaultThemeColours };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/store/modules/user-preferences/user-preferences.ts